<template>
  <div class="llm-width">
    <div style="margin-bottom: 10px">
      <template v-if="filterable">
        <template v-if="taskTypes.length > 0">
          <a-space align="start">
            <p style="width: 60px;line-height: 32px">Task type:</p>
            <!--                        <a-cascader-->
            <!--                                @change="filterByTaskType"-->
            <!--                                v-model:value="value" :options="options" placeholder="Please select" />-->

            <a-radio-group v-model:value="filterTaskType" @change="filterByTaskType">
              <a-radio-button value="All" style="margin: 5px">All</a-radio-button>
              <template v-for="(t, tIndex) in taskTypes" :key="tIndex">
                <a-radio-button :value="t['Task subclass']" style="margin: 5px">
                  <task-type-tag :task-type="t['Task classification']" :text="t['Task subclass']"/>
                </a-radio-button>
              </template>
            </a-radio-group>
          </a-space>
        </template>
      </template>
      <a-button v-else @click="redo"><redo-outlined/></a-button>
    </div>
    <a-table
      :scroll="{x: 1100}"
      :columns="columns"
      :data-source="dataSource"
      :loading="loading"
      :pagination="{showTotal: total=> total + ' items'}">
      <template
        #customFilterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
      >
        <div style="padding: 8px">
          <a-input
            ref="searchInput"
            :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
          />
          <a-button
            type="primary"
            size="small"
            style="width: 90px; margin-right: 8px"
            @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
          >
            <template #icon><SearchOutlined /></template>
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="handleReset(clearFilters)">
            Reset
          </a-button>
        </div>
      </template>
      <template #customTitle>
        <span>
          MCQ <sup style="color: red">NEW</sup>
        </span>
      </template>
      <template #testInfo="{record}">
        <a-button type="link" @click="()=>showModal1(record, index)" v-if="record.test_info">
          <file-markdown-outlined/>
        </a-button>
        <a-tooltip v-else title="No MCQ available for this question.">
          <file-markdown-outlined/>
        </a-tooltip>
      </template>
      <template #customFilterIcon="{ filtered }">
        <search-outlined :style="{ color: filtered ? '#108ee9' : undefined }" />
      </template>
      <template #bodyCell="{ column, record }">
        <div v-if="column.dataIndex === 'Question'" style="text-align: justify">
          <b>Q{{record.index}}:</b>&nbsp;
          <a-textarea
            auto-size
            v-if="editable && editableData[record.index]"
            v-model:value="editableData[record.index][column.dataIndex]"
            style="margin: -5px 0"
          />
          <span v-else>
                        {{ record[column.dataIndex] }}
                    </span>
          &nbsp;
          <a-space v-if="editableData[record.index]">
            <a-typography-link @click="save(record.index)">Save</a-typography-link>
            <a-popconfirm title="Sure to cancel?" @confirm="cancel(record.index)">
              <a>Cancel</a>
            </a-popconfirm>
          </a-space>
          <span v-else-if="editable">
                        <a @click="edit(record.index)">Edit</a>
                    </span>
        </div>
        <template v-else-if="column.dataIndex === 'Task subclass'">
          <!--                0failed 1start 2improve_prompt 3tool_score 4workflow 5code 6summary 7completed-->
          <task-type-tag :task-type="record['Task classification']" :text="record[column.dataIndex]"/>
        </template>

        <template v-else-if="column.dataIndex === 'Files'">
          <div v-for="(f, fIndex) in record[column.dataIndex]" :key="fIndex">
            <a @click="()=>down_file(f.path)">
              {{f.name}} <download-outlined/>
            </a>
          </div>
        </template>
        <template v-else-if="column.dataIndex === '里程碑参考文件'">
          <div v-for="(f, fIndex) in record[column.dataIndex]" :key="fIndex">
            <a @click="()=>down_file(f.path)">
              {{f.name}} <download-outlined/>
            </a>
          </div>
          <a
            v-if="(!record[column.dataIndex]) || (Array.isArray(record[column.dataIndex]) && record[column.dataIndex].length === 0)"
            color="processing"
            @click="()=>showModal(record, '参考里程碑', 'Milestones for evaluation', 'milestone')"
            style="cursor: pointer">
            View
          </a>
        </template>
        <template v-else-if="column.dataIndex === 'QuestionType'">
          <a-tag :color="record[column.dataIndex] === 'open'? 'pink': 'green'">
            {{record[column.dataIndex]}}
          </a-tag>
        </template>

        <template v-else-if="column.dataIndex === '参考step数'">
          <a-button type="primary" size="small" @click="()=>showModal(record, '参考step', column.title, 'step')" style="cursor: pointer">
            <template #icon>
              <eye-outlined/>
            </template>
            {{record[column.dataIndex]}}
          </a-button>
        </template>

        <template v-else-if="column.dataIndex === '参考里程碑'">
          <a-tag color="processing" @click="()=>showModal(record, column.dataIndex, column.title, 'milestone')" style="cursor: pointer">
            View
          </a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'rounds'">
          <template v-if="Array.isArray(record.task_id) ">
            <div v-for="(task, tIndex) in record.task_id" :key="tIndex">
              <a-button
                size="small"
                type="link"
                :href="'/Benchmark/Detail?task_id=' + task + '&q=' + record.Question"
                target="_blank"  rel="opener">
                round={{ roundNames[tIndex]}}
              </a-button>
            </div>
          </template>
          <span v-else>
            rounds
          </span>
        </template>

      </template>
    </a-table>
    <a-modal v-model:open="open" :title="modalTitle" @ok="handleOk">
      <a-divider/>
      <a-form
        v-if="editable"
        ref="formRef"
        name="dynamic_form_item"
      >
        <a-form-item
          v-for="(text, index) in texts"
          :key="text"
          :label="index + 1"
          :name="['texts', index, 'value']"
        >
          <a-textarea auto-size v-model:value="text.value"/>
        </a-form-item>
      </a-form>
      <div v-else>
        <p v-for="(text, index) in miletones" :key="index">
          <span v-if="miletones.length > 1">{{index+ 1}}. </span> {{text}}
        </p>
      </div>
    </a-modal>

    <a-modal v-model:open="open1"
             @ok="handleOk1"
             :title="'Q' + mcq.index + '.Multi-choice question' "
             width="800px" body-style="word-wrap: break; ">
      <a-divider/>
      <p>
        {{mcq.test_info['Multi_choice_question']}}
      </p>
      <template v-if="Array.isArray(mcq?.test_info?.Options)">
        <p v-for="(c, index) in mcq.test_info.Options" :key="index">
          <a-button size="small" style="margin-right: 5px;">{{c.title}}{{c.text}}</a-button>
        </p>
      </template>
      <p>
        {{mcq.test_info['Option_description']}}
      </p>
      <a-divider/>
      <p>
        <b>Answers:</b> {{mcq.test_info['Answer']}}
      </p>
    </a-modal>
  </div>
</template>

<script>
    import { cloneDeep } from 'lodash-es';
    import {
        get_batch_task_list,
        get_task_type_color,
        post_batch_task_list_fix,
    } from "../utils/biomed.api";
    import {formatTime, down_file, get_args, isDEV} from "../utils/request";
    import {
        RedoOutlined, SearchOutlined,
        EyeOutlined,
        DownloadOutlined,
        FileMarkdownOutlined
    } from '@ant-design/icons-vue';
    import TaskTypeTag from "./TaskTypeTag";
    import {jy_tip} from "@/utils/vue.tool";
    export default {
        name: "TaskList",
        props: ['columns', 'filterable'],
        components: {
            RedoOutlined, SearchOutlined,
            EyeOutlined,
            DownloadOutlined,
            TaskTypeTag,
            FileMarkdownOutlined
        },
        data(){
            let {editable} = get_args();
            return {
                editable: editable === '1',
                editKey: '',
                editableData: [],
                dataIndex: '',
                index : 0,
                dataSource: [],
                initData: [],
                taskTypes: [],
                options: [],
                filterTaskType: '',
                loading: true,
                open: false,
                open1: false,
                mcq: {},
                miletones: [],
                texts: [],
                modalTitle: '',
                roundNames: [
                    '0',
                    '1',
                    '2(CMA)',
                    '2(IMF)',
                    '3(CMA)',
                    '3(IMF)',
                ],
            }
        },
        created(){
            this.getItems();
        },
        methods: {
            get_task_type_color,
            formatTime,
            // filterByTaskType(values){
            //     console.log('filterByTaskType', values);
            //     let [, value] = values;
            //     if(value) this.dataSource = this.initData.filter(item=>item['Task subclass'] === value);
            // },
            filterByTaskType(e){
                console.log('filterByTaskType', e);
                let {value} = e.target;
                this.dataSource = value === 'All'? this.initData: this.initData.filter(item=>item['Task subclass'] === value);
            },
            handleSearch (selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters({ confirm: true });
                this.searchText = '';
            },
            getItems(){
                let obj = this;
                obj.loading = true;
                let options = ['O', 'P', 'M', 'S', 'V'].map(o=>{
                    return {
                        value: o,
                        label: o,
                        children: []
                    }
                });
                get_batch_task_list( data=>{
                    console.log('get_batch_task_list', data);
                    obj.loading = false;
                    data = data || [];
                    let taskTypes = [];
                    obj.dataSource = data || [];
                    let k = 'Task subclass';
                    data.map(item=>{
                        let v = item[k];
                        let cIndex = options.findIndex(o=>o.value === item['Task classification']);
                        let {children} = options[cIndex] || [];
                        if(taskTypes.findIndex(t=> t[k] === v) === -1){
                            taskTypes = [...taskTypes, item];
                        }
                        if(cIndex > -1){
                            if(children.findIndex(t=> t.value === v) === -1){
                                children = [...children, {value: v, label: v}];
                            }
                        }

                        console.log(v, cIndex, children);
                        options[cIndex].children = [...children];
                    });

                    obj.taskTypes = taskTypes;
                    obj.initData = data;
                    obj.options = options;
                })
            },
            showModal(record, dataIndex, title, editKey){
                let {editable} = this;
                this.open = true;
                this.editKey = editKey;
                this.miletones = record[dataIndex];
                this.dataIndex = dataIndex;
                this.index = record.index;
                if(editable){
                    this.texts = this.miletones.map(m=>{
                        return {value: m};
                    })
                }
                this.modalTitle = 'Q' + record.index + ': ' + title;
            },
            handleOk(){
                if(this.editable){
                    let {texts, editKey, index, dataIndex} = this;
                    let data = texts.map(text=> text.value);
                    console.log(isDEV, editKey, dataIndex, data);
                    // if(isDEV) return;
                    post_batch_task_list_fix(editKey, {Index: index, [editKey]: data}, (res)=>{
                        console.log('post_batch_task_list_fix', editKey, res);
                        jy_tip(res.message);
                        let index1 = this.dataSource.findIndex(item=>item.index === index);
                        this.dataSource[index1][dataIndex] = data;
                    });
                }
                this.open = false;
            },
            down_file(file_path){
                down_file({file_path})
            },
            edit(index){
                this.editableData[index] = cloneDeep(this.dataSource.filter(item => index === item.index)[0]);
            },
            save(Index){
                console.log(this.editableData[Index]);
                let {Question} = this.editableData[Index];
                post_batch_task_list_fix('question', {Question, Index}, (res)=>{
                    console.log('post_batch_task_list_fix_question', res);
                    jy_tip(res.message);
                    let index = this.dataSource.findIndex(item=>item.index === Index);
                    this.dataSource[index].Question = Question;
                    delete this.editableData[Index];
                });

            },
            cancel(index){
                delete this.editableData[index];
            },

            showModal1(record){
                this.mcq = record;
                this.open1 = true;
                console.log(record);
            },
            handleOk1(){
                this.open1 = false;
            }
        }
    }
</script>
<style>

</style>
